import { render, staticRenderFns } from "./SignPosts.vue?vue&type=template&id=664da1ee&scoped=true"
import script from "./SignPosts.vue?vue&type=script&lang=js"
export * from "./SignPosts.vue?vue&type=script&lang=js"
import style0 from "./SignPosts.vue?vue&type=style&index=0&id=664da1ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664da1ee",
  null
  
)

export default component.exports